export default {"src":"/_next/static/media/civics.a0ea4020.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};